import { styled } from "@mui/material";
import Chip from "@mui/material/Chip";
import type { ChipProps } from "@mui/material/Chip";

interface BadgeDeltaContainerProps extends ChipProps {}

const BadgeDeltaContainer = styled(Chip)<BadgeDeltaContainerProps>(({ theme }) => ({
  height: "auto",
  cursor: "default",
  gap: theme.spacing(0.5),

  "& .MuiChip-label": {
    padding: "0",
    fontWeight: "500",
    textAlign: "center",
    fontVariantNumeric: "tabular-nums",
  },

  // if label and icon then padding is 4px
  "& .MuiChip-icon + .MuiChip-label": {
    paddingLeft: theme.spacing(0.5),
  },

  "&.MuiChip-sizeSmall > .MuiChip-label": {
    fontSize: "12px",
    lineHeight: "18px",
  },

  "&.MuiChip-sizeMedium > .MuiChip-label": {
    fontSize: "14px",
    lineHeight: "20px",
  },

  "& .MuiChip-icon": {
    marginLeft: "0",
  },

  "&.MuiChip-sizeSmall > .MuiChip-icon": {
    fontSize: "15px",
  },

  "&.MuiChip-sizeMedium > .MuiChip-icon": {
    fontSize: "16px",
  },

  "&.MuiChip-sizeSmall": {
    padding: theme.spacing(0, 0.5),
  },

  "&.MuiChip-sizeMedium": {
    padding: theme.spacing(0.25, 0.75),
  },
}));
export default BadgeDeltaContainer;
